export const i18nConstants = {
    CHANGE_LANGUAGE: 'CHANGE_LANGUAGE'
};
